import {
	FileImageOutlined,
	FormOutlined,
	PlusCircleFilled,
	// FormOutlined,
	// PlusCircleFilled,
} from "@ant-design/icons";
import { Form, Input, Modal, Switch, Select, Space } from "antd";
import BlockLinkItem from "components/BlockLinkItem";
import React, { useEffect, useState } from "react";
// import ReactQuill from "react-quill";
import { api } from "services/api";
import Swal from "sweetalert2";
import { IBlock } from "types";
// import { IAddClasses } from "types";
import { getBase64Img } from "utils";

const { Option } = Select;

export const AddClassModal: React.FC<any> = ({ ...props }) => {
	const [option, setOption] = useState<string>("");
	const [classStatus, setClassStatus] = useState<boolean>(false);
	const [isActive, setIsActive] = useState<boolean>(false);
	const [isPay, setIsPay] = useState<boolean>(false);
	// const [value, setValue] = useState<string>("");
	const [imageWasAdded, setImageWasAdded] = useState<boolean>(false);
	const {
		form,
		blocks,
		isOpen,
		setCurrentImgURL,
		setIsOpen,
		setBlocks,
		setFromCreate,
		currentImgURL,
		setCourseStatus,
		setIsOpenBlock,
		setSelectedBlockId,
		setIsOpenEditBlock,
		setProcessing,
		courseId: moduleId,
		titlePage,
	} = props;

	const handleRegister = (values: any) => {
		setProcessing(true);
		api
			.post("/classes", values)
			.then((result) => {
				if ([200, 201].includes(result.status)) {
					const {
						data: { feedback },
					} = result;
					form.resetFields();
					setProcessing(false);

					let message = feedback["success"] + ", " + feedback["details"];

					Swal.fire({
						icon: "success",
						text: message,
						confirmButtonColor: "#63b8cd",
					}).then(() => {
						setIsOpen(false);
						setCourseStatus(false);
						setIsPay(false);
						setIsActive(false);
						setClassStatus(false);
						setCurrentImgURL("");
						setBlocks([]);
						// setValue("");
					});
					const html = document.getElementsByTagName("html");
					html.item(0)?.classList.remove("swal2-shown", "swal2-height-auto");
					document.body.classList.remove("swal2-shown", "swal2-height-auto");
				}
			})
			.catch((err) => {
				const status = err.response.status;
				const { feedback, errors } = err.response?.data;
				if (
					status === 400 ||
					status === 401 ||
					status === 404 ||
					status === 403 ||
					status === 500
				) {
					Swal.fire({
						icon: "error",
						text: feedback["error"]
							? feedback["error"]
							: "Desculpe, ocorreu algum problema =( Por favor tente novamente",
					});
					const html = document.getElementsByTagName("html");
					html.item(0)?.classList.remove("swal2-shown", "swal2-height-auto");
					document.body.classList.remove("swal2-shown", "swal2-height-auto");
				}
				if (status === 422) {
					Swal.fire({
						icon: "error",
						text: errors?.message
							? errors?.message
							: "Desculpe, ocorreu algum problema =( Por favor tente novamente",
					});
					const html = document.getElementsByTagName("html");
					html.item(0)?.classList.remove("swal2-shown", "swal2-height-auto");
					document.body.classList.remove("swal2-shown", "swal2-height-auto");
				}
			});
	};

	useEffect(() => {}, [blocks]);

	return (
		<Modal
			title={<p style={{ margin: 0 }}>{titlePage} - Cadastrar nova aula</p>}
			open={isOpen}
			maskClosable={false}
			okText="Cadastrar aula"
			cancelText="Cancelar"
			onOk={() => {
				form
					.validateFields()
					.then((values: any) => {
						const allValues = imageWasAdded
							? {
									...values,
									status: classStatus ? "publish" : "pending",
									image: currentImgURL,
									visibility: option,
									is_active: isActive,
									payment_required: isPay ? "pay" : "free",
									// content: value,
									order: "2",
									module_id: `${moduleId}`,
									blocks: blocks,
							  }
							: {
									...values,
									status: classStatus ? "publish" : "pending",
									visibility: option,
									is_active: isActive,
									payment_required: isPay ? "pay" : "free",
									// content: value,
									order: "2",
									module_id: `${moduleId}`,
									blocks: blocks,
							  };
						handleRegister(allValues);
					})
					.catch((info: any) => {
						// console.log("Validate Failed:", info);
					});
			}}
			onCancel={() => {
				setIsOpen(!isOpen);
				form.resetFields();
				setCurrentImgURL("");
				setBlocks([]);
				// setValue("");
				setCourseStatus(false);
				setIsPay(false);
				setIsActive(false);
				setClassStatus(false);
				form.resetFields();
			}}
			className="m-modal-classes"
		>
			<Form form={form} name="new-course" autoComplete="off">
				<div className="m-classes-modal">
					<div
						className="m-classes-modal__login-info"
						style={{ height: "500px", overflow: "auto" }}
					>
						<div className="m-classes-modal__login-info__avatar">
							{currentImgURL ? (
								<img
									src={currentImgURL}
									alt=""
									width="70%"
									height="70%"
									style={{ margin: "0 auto" }}
								/>
							) : (
								<FileImageOutlined />
							)}
							<label
								htmlFor="avatar"
								className="m-classes-modal__login-info__avatar__btn"
							>
								Enviar foto de capa
							</label>
							<Input
								id="avatar"
								type="file"
								accept="image/*"
								style={{ display: "none" }}
								onChange={(e) => {
									if (e.target.files?.[0]) {
										setImageWasAdded(true);
										getBase64Img(e.target.files?.[0] as Blob, setCurrentImgURL);
									}
								}}
							/>
						</div>
						<div
							className="m-classes-modal__login-info__inputs"
							style={{ justifyContent: "space-evenly" }}
						>
							<Form.Item
								name="title"
								rules={[
									{
										required: true,
										message: "Título necessário",
									},
								]}
							>
								<Input placeholder="Título da aula" />
							</Form.Item>
							<Form.Item
								name="description"
								rules={[
									{
										required: true,
										message: "Descrição necessária",
									},
								]}
							>
								<Input placeholder="Descrição da aula" />
							</Form.Item>

							<div
								style={{
									display: "flex",
									width: "100%",
									alignItems: "center",
									flexDirection: "column",
								}}
							>
								<div
									style={{
										display: "flex",
										width: "80%",
										alignItems: "center",
										justifyContent: "center",
									}}
								>
									<Form.Item
										name="visibility"
										rules={[
											{
												required: true,
												message: "Visibilidade necessária",
											},
										]}
									>
										<Select
											placeholder="Visibilidade"
											className="m-classes-modal__select"
											onChange={(e) => setOption(e)}
										>
											<Option value="public">Público</Option>
											<Option value="private">Privado</Option>
										</Select>
									</Form.Item>
								</div>
								<div
									style={{
										display: "flex",
										width: "100%",
										alignItems: "center",
										marginTop: "20px",
									}}
								>
									<div className="m-classes-modal__status">
										<p>Publicado</p>
										<Switch
											checked={classStatus}
											onClick={(e) => setClassStatus(e)}
										/>
									</div>
									<div className="m-classes-modal__status">
										<p>Pago</p>
										<Switch checked={isPay} onClick={(e) => setIsPay(e)} />
									</div>
									<div className="m-classes-modal__status">
										<p>Ativo</p>
										<Switch
											checked={isActive}
											onClick={(e) => setIsActive(e)}
										/>
									</div>
								</div>
							</div>
							{/* <div className="m-classes-modal__textarea">
								<ReactQuill theme="snow" value={value} onChange={setValue} />
							</div> */}
						</div>
					</div>
					<div className="m-classes-modal__blocks-content">
						<div
							className="m-classes-modal__login-info"
							style={{
								height: "500px",
								overflow: "auto",
							}}
						>
							{blocks.length === 0 && (
								<p
									style={{
										height: "100%",
										width: "100%",
										display: "flex",
										alignItems: "center",
										justifyContent: "center",
									}}
								>
									Adicione um bloco para visualizar seus respectivos items.
								</p>
							)}
							{blocks.map((block: IBlock, index: any) => {
								const label =
									block.type === "text"
										? "Textual"
										: block.type === "image"
										? "mídia - Imagem"
										: block.type === "youtube"
										? "vídeo - Youtube"
										: block.type === "vimeo"
										? "vídeo - Vimeo"
										: "mídia - Arquivo";
								return (
									<div
										key={index}
										className="m-classes-modal__blocks-content__item"
									>
										<div
											style={{
												display: "flex",
												justifyContent: "space-between",
											}}
										>
											<p>
												Bloco {label} - Ordem {block.order}
											</p>
											<div className="m-classes-modal__blocks-content__item__btns">
												<Space size="small">
													<FormOutlined
														className="edit"
														onClick={() => {
															setSelectedBlockId(index);
															setIsOpenEditBlock(true);
															setFromCreate(true);
														}}
													/>
												</Space>
											</div>
										</div>
										<div className="m-classes-modal__blocks-content__item__content">
											{block.type === "text" && (
												<div
													dangerouslySetInnerHTML={{
														__html: block.content,
													}}
												></div>
											)}
											{block.type === "image" && (
												<img
													src={block.content}
													alt=""
													width="60%"
													height="100%"
												/>
											)}
											{block.type === "youtube" && (
												<BlockLinkItem block={block} />
											)}
											{block.type === "vimeo" && (
												<BlockLinkItem block={block} />
											)}
											{block.type === "archive" && (
												<a
													href={block.content}
													target="_blank"
													rel="noreferrer"
													style={{
														padding: "10px 20px",
														backgroundColor: "#f0f0f0",
														color: "#000",
														borderRadius: "5px",
													}}
												>
													Ver Arquivo
												</a>
											)}
										</div>
									</div>
								);
							})}
						</div>
						<button
							type="button"
							onClick={() => {
								setIsOpenBlock(true);
								setFromCreate(true);
							}}
						>
							<PlusCircleFilled /> Inserir Bloco
						</button>
					</div>
				</div>
			</Form>
		</Modal>
	);
};
